export type ModelToken =
  | 'SsdMobilenetv1Model'
  | 'MtcnnModel'
  | 'FaceExpressionModel'
  | 'FaceLandmarkModel'
  | 'FaceRecognitionModel'
  | 'TinyFaceDetectorModel'
  | 'AgeAndGenderModel';

export const SsdMobilenetv1Model: ModelToken = 'SsdMobilenetv1Model';
export const MtcnnModel: ModelToken = 'MtcnnModel';
export const FaceExpressionModel: ModelToken = 'FaceExpressionModel';
export const FaceLandmarkModel: ModelToken = 'FaceLandmarkModel';
export const FaceRecognitionModel: ModelToken = 'FaceRecognitionModel';
export const TinyFaceDetectorModel: ModelToken = 'TinyFaceDetectorModel';
export const AgeAndGenderModel: ModelToken = 'AgeAndGenderModel';
